/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMonitoModel = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M2 2.2h20v9h-.54L20 10.287V4.2H4v8h1.446l3.007-4.811 3.635 5.192 3.472-3.968 1.633 2.178-1.702 1.064-.05-.068-.194.221L12 14.038v1.68l-.088.1-3.365-4.807L6.554 14.2H4v6h7v2H2v-20z"
        fill="currentcolor"
      />
      <path
        d="m19 12.02-5 3.126v5.108l5 3.125 5-3.125v-5.108l-5-3.125zm-1 6.734v1.642l-2-1.25v-1.642l2 1.25zm4 .392-2 1.25v-1.642l2-1.25v1.642zm-.887-3.446L19 17.02l-2.113-1.32L19 14.38l2.113 1.32z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMonitoModel as MonitoModel };
